/**
 * Created by pbo on 26/09/16.
 */


angular.module('taric.auth.userhelper', ['taric.auth.model', 'ng', 'common.config', 'angular-jwt'])
    .factory('UserHelper', function ($rootScope, AuthorizeModel, $http, CONSTANTS) {
        var helper = {
            getUser: function() {
                $http.defaults.headers.common.Authorization = 'Bearer ' + AuthorizeModel.jwt;
                var userInfo = {username: null, fullname: null};

                AuthorizeModel.getUser().then(function (result) {
                    userInfo = result;
                    AuthorizeModel.user = userInfo.username;
                    AuthorizeModel.userName = userInfo.fullname;
                    // Used for test
                    if (CONSTANTS.fakeSSO === true) {
                        AuthorizeModel.userName = CONSTANTS.fakeSSOusername;
                    }
                    $rootScope.$broadcast('userName');
                }, function(error){
                    // Token invalid
                    if (CONSTANTS.credentialSetting === 'BASIC') {
                        AuthorizeModel.init();
                        $rootScope.$broadcast('enableLogin');
                    } else {
                        $rootScope.$broadcast('userName');
                    }
                });
            }
        };
        return helper;
    });



// WEBPACK FOOTER //
// ./app/taric/auth/user-helper.js